module.exports = __webpack_public_path__ + "media/country_flags/je-2bc744e1.png";